export default __webpack_public_path__ + "static/media/mobile.10b7017d.svg";